<div class="modal-header">
  <h5 class="modal-title">Deposit / Withdraw Summary</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <div class="date-filter mb-3">
    <div class="date-filter-field">
      <label class="form-label small text-muted mb-1">From</label>
      <input type="date" class="form-control form-control-sm" [(ngModel)]="filter.date_from" [max]="today">
    </div>
    <div class="date-filter-field">
      <label class="form-label small text-muted mb-1">To</label>
      <input type="date" class="form-control form-control-sm" [(ngModel)]="filter.date_to" [max]="today">
    </div>
    <div class="date-filter-actions">
      <button type="button" class="btn btn-sm btn-primary" (click)="load()" [disabled]="isLoading">Apply</button>
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearDateFilter()" [disabled]="isLoading || (!filter.date_from && !filter.date_to)">All</button>
    </div>
  </div>

  <div *ngIf="rangeError" class="alert alert-danger py-2 mb-3">
    {{rangeError}}
  </div>

  <p *ngIf="isLoading" class="text-muted mb-0">Loading ...</p>

  <ng-container *ngIf="!isLoading && data?.status">
    <div class="mb-3">
      <div class="fw-bold">{{data.player?.code}} <span class="text-muted fw-normal">{{data.player?.name}}</span></div>
      <div class="text-muted small">{{getPeriodText()}}</div>
    </div>

    <div class="row g-2 mb-3">
      <div class="col-6 col-md-3" *ngFor="let item of data.cards">
        <div class="summary-box">
          <div class="summary-label">{{item.label}}</div>
          <div class="summary-value">{{item.deposit | number:'1.2-2'}}</div>
          <div class="summary-sub">Withdraw {{item.withdraw | number:'1.2-2'}}</div>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-striped mb-0">
        <thead>
          <tr>
            <th>Type</th>
            <th>Code</th>
            <th>Name</th>
            <th class="text-end">Deposit</th>
            <th class="text-end">Withdraw</th>
            <th class="text-end">Net</th>
            <th class="text-end">Txns</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of data.rows">
            <td>{{row.relation}}</td>
            <td>{{row.code}}</td>
            <td>{{row.name}}</td>
            <td class="text-end">{{row.deposit | number:'1.2-2'}}</td>
            <td class="text-end">{{row.withdraw | number:'1.2-2'}}</td>
            <td class="text-end" [ngClass]="{'text-danger': row.net < 0}">
              {{row.net | number:'1.2-2'}}
            </td>
            <td class="text-end">{{row.transactions}}</td>
          </tr>
          <tr *ngIf="!data.rows || data.rows.length === 0">
            <td colspan="7" class="text-center text-muted py-3">No player rows found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>

  <div *ngIf="!isLoading && data && !data.status" class="alert alert-danger mb-0">
    {{data.message || 'Unable to load summary'}}
  </div>
</div>
